import { assert_array_not_empty, assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestTokensUpdateVisibility extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_TOKENS_UPDATE_VISIBILITY;

  entity_id!: string;
  tokens!: DTO__token[];

  /*
   * METHODS
   */

  constructor(entity_id: string = '') {
    super();

    this.entity_id = entity_id;
    this.tokens = [];
  }

  assert_standard_fields(): void {
    assert_string_object_id(this.entity_id);

    assert_array_not_empty(this.tokens);
  }
}
